import {
  useEffect, useRef,
} from 'react';
import { useDispatch } from 'react-redux';
import { ADMIN_MAP_PAGES } from '~/_shared/components/modal/modal.constants';
import { Page } from '~/_shared/constants/routes';
import { useGetCurrentPageInfo } from '~/topBar/navigation/navigation.helpers';
import { setHasNavigatedToHome } from './navigation.actionCreators';

export const useHasNavigatedToHome = () => {
  const dispatch = useDispatch();
  const currentPage = useGetCurrentPageInfo().page;
  const previousPageRef = useRef(currentPage);

  useEffect(() => {
    const previousPage = previousPageRef.current;
    previousPageRef.current = currentPage;

    if (currentPage === Page.ADMIN_HOME && ADMIN_MAP_PAGES.has(previousPage)) {
      dispatch(setHasNavigatedToHome(true));
    }
    else if (previousPage === Page.ADMIN_HOME && currentPage !== Page.ADMIN_HOME) {
      dispatch(setHasNavigatedToHome(false));
    }
  }, [currentPage, dispatch]);
};
